@if (shouldShowBanner$ | async) {
  <div
    (click)="handleClick()"
    class="bg-black px-8 py-6 text-center text-white uppercase"
    role="button">
    Zapisz się do naszego newslettera!
  </div>
}

<p-dialog
  [(visible)]="showNewsletterDialog"
  appPrimengDialog
  header="Zapisz się na nasz newsletter">
  <div class="mb-4">
    @if (showNewsletterDialog) {
      <app-newsletter-form
        (submitClickEvent)="handleSubmitClickEvent($event)" />
    }
  </div>
</p-dialog>
